import React from "react";

import { ThemeProvider } from "./src/context/ThemeContext";

import "./src/assets/scss/index.scss";
import "./src/css/index.css";

export const wrapRootElement = ({ element }: any) => {
  return <ThemeProvider>{element}</ThemeProvider>;
};

// Logs when the client route changes
export const onRouteUpdate = ({ location }: any) => {

  if (globalThis?.window !== undefined) {

    const storedPageViewInteraction = readLocalStorage("pageViewInteraction");
    const pageViewCount = readLocalStorage("pageViewCount") ?? 0;

    //add a page tracker
    let pageViewList = [...storedPageViewInteraction];

    if (!pageViewList?.includes(location.href)) {
      pageViewList.push(location.href);

      writeLocalStorage("pageViewInteraction", JSON.stringify(pageViewList));

      //add a page counter
      const newCount = pageViewCount + 1;
      writeLocalStorage("pageViewCount", newCount.toString());
    }
  }

};

export const onInitialClientRender = () => {
  //check for first session in local storage
  const session = readLocalStorage("FirstSession");

  // First time session
  if (session === "undefined" || session === null || session === "") {
    writeLogic("FirstSession");
  } else {
    writeLogic("ReturningSession");
  }

  const suggest_country = getCookie("gvx-analytics-suggest-country") || "";
  const site_country = getCookie("gvx-analytics-site-country-code") || "";

  const first_session_cookie = getCookie("FirstSession") || "";
  const returning_session_cookie = getCookie("ReturningSession") || "";

  //add location specific data
  writeLocalStorage(
    "gvx-analytics",
    JSON.stringify({
      city: getCookie("gvx-analytics-city") || "",
      country: getCookie("gvx-analytics-country") || "",
      device: getCookie("gvx-analytics-device") || "",
      region: getCookie("gvx-analytics-region") || "",
      timezone: getCookie("gvx-analytics-timezone") || "",
      suggest_country: suggest_country?.toLowerCase(),
      site_country: site_country?.toLowerCase(),
      raw_cookies: {
        firstSession:
          first_session_cookie.length > 0 ? extractCookieStringToObject(first_session_cookie) : {},
        returningSession:
          returning_session_cookie.length > 0 ? extractCookieStringToObject(returning_session_cookie) : {}
      }
    })
  );
};

export const onClientEntry = async () => {
  if (typeof IntersectionObserver === "undefined") {
    await import("intersection-observer");
  }
};

function writeLocalStorage(paramName: string, paramValue: string) {
  if (globalThis?.window !== undefined) {
    try {
      globalThis?.window.localStorage.setItem(paramName, paramValue);
    } catch (error) {
      console.error(
        `Error stringifying ${paramValue} for localStorage: `,
        error
      );
    }
  }
}
function getCookie(name: string) {
  let cookieArray = document.cookie.split(";");
  for (const element of cookieArray) {
    let cookiePair = element.trim().split("=");
    if (cookiePair[0] === name) {
      return decodeURIComponent(cookiePair[1]);
    }
  }
  return "";
}

/**
 * Takes a query string and extracts the key-value pairs into an object.
 * Decodes URL encoded strings and returns an empty object if the input string is empty.
 * @param {string} queryString - The query string to extract key-value pairs from
 * @returns {object} - An object containing the extracted key-value pairs
 */
function extractCookieStringToObject(queryString: string): object {

  if (!queryString || queryString?.length < 1) {
    return {};
  }

  return (
    queryString?.split("&").reduce((acc: any, pair) => {
      const [key, value] = pair.split("=");
      acc[key] = decodeURIComponent(value || "");
      return acc;
    }, {}) || {}
  );
}

function readLocalStorage(paramName: string) {
  let storageDetails = '';

  try {
    if (globalThis?.window !== undefined)
      storageDetails = JSON.parse(globalThis?.window?.localStorage?.getItem(paramName) || "");
  } catch (error) {
    console.warn(`Error parsing :: ${paramName} from localStorage: `, error);
  }

  return storageDetails;
}

function writeLogic(paramName: string) {
  const sourceDetails = getTrafficSource(paramName);
  if (!sourceDetails) {
    return false;
  }

  if (globalThis?.window !== undefined) {
    globalThis?.window.localStorage.setItem(paramName, JSON.stringify(sourceDetails));
  }

  return sourceDetails;
}

function getParam(s: string, q: string) {
  try {
    let match = new RegExp("[?&]" + q + "=([^&]+)").exec(s);
    return match ? match[1] : "";
  } catch (e) {
    console.error(e);
    return "";
  }
}

function calculateTrafficSource() {
  let ref_domain = "";
  let ref_search: string;

  let source = "",
    medium = "",
    campaign = "",
    term = "",
    content = "",
    adgroup = "",
    ttclid = "",
    msclkid = "",
    gclid = "",
    fbclid = "",
    wbraid = "",
    gbraid = "",
    pageviewcount: any = readLocalStorage("pageViewCount") || 0;

  let search_engines = [
    ["bing", "q"],
    ["google", "q"],
    ["yahoo", "q"],
    ["baidu", "q"],
    ["yandex", "q"],
    ["ask", "q"]
  ]; //List of search engines

    let ref: any = document?.referrer ? new URL(document?.referrer) : "";
  ref_domain = ref?.hostname || "";
  ref_search = ref?.search || "";

  // Checks for campaign parameters
  let currentHostname = globalThis?.window.location.hostname;
  let page_uri = globalThis?.window.location.href;
  let url_search = globalThis?.window.location.search;

  // Checks for click id parameters, that we want to save all the time
  ttclid = getParam(url_search, "ttclid");
  msclkid = getParam(url_search, "msclkid");
  fbclid = getParam(url_search, "fbclid");
  gclid = getParam(url_search, "gclid");
  wbraid = getParam(url_search, "wbraid");
  gbraid = getParam(url_search, "gbraid");

  if (url_search.includes("utm_source")) {
    source = getParam(url_search, "utm_source");
    medium = getParam(url_search, "utm_medium");
    campaign = getParam(url_search, "utm_campaign");
    term = getParam(url_search, "utm_term");
    content = getParam(url_search, "utm_content");
    adgroup = getParam(url_search, "utm_adgroup");
  } else if (url_search.includes("gvi_source")) {
    source = getParam(url_search, "gvi_source");
    medium = getParam(url_search, "gvi_medium");
    campaign = getParam(url_search, "gvi_campaign");
    term = getParam(url_search, "gvi_term");
    content = getParam(url_search, "gvi_content");
  } else if (gclid || wbraid || gbraid) {
    source = "g";
    medium = getParam(url_search, "utm_medium") || "cpc";
    campaign = getParam(url_search, "utm_campaign") || "(not set)";
  } else if (fbclid) {
    source = "fb";
    medium = getParam(url_search, "utm_medium") || "cpc";
    campaign = getParam(url_search, "utm_campaign") || "(not set)";
  } else if (msclkid) {
    source = "bing";
    medium = getParam(url_search, "utm_medium") || "cpc";
    campaign = getParam(url_search, "utm_campaign") || "(not set)";
  } else if (ttclid) {
    source = "tiktok";
    medium = getParam(url_search, "utm_medium") || "cpc";
    campaign = getParam(url_search, "utm_campaign") || "(not set)";
  } else if (ref) {
    if (ref_domain !== currentHostname) {
      medium = "referral";
      source = ref_domain || "";
    }

    if (ref_domain === currentHostname) {
      return false;
    }

    // Extract term for organic source
    for (const element of search_engines) {
      if (ref_domain?.includes(element[0])) {
        medium = "organic";
        source = element[0];
        term = getParam(ref_search, element[1]) || "(not provided)";
        break;
      }
    }
  }

  if (/paid/gi.test(medium)) {
    medium = "cpc";
  }

  pageviewcount = pageviewcount++; //getParam(url_search, 'pageviewcount')
  const userAgent = navigator?.userAgent;

  return {
    uri: page_uri,
    source,
    medium,
    campaign,
    term,
    content,
    adgroup,
    gclid,
    msclkid,
    ttclid,
    fbclid,
    wbraid,
    gbraid,
    pageviewcount,
    userAgent
  };
}

function getTrafficSource(cookieName?: string, hostname?: string) {
  const trafficSources = calculateTrafficSource();

  if (!trafficSources) {
    return false;
  }

  //if the page is the outreach-form
  if (/outreach-form/i.test(trafficSources?.uri)) {
    trafficSources.medium = 'Event';
    trafficSources.source = 'University';
    trafficSources.term = 'Events';
    trafficSources.campaign = '';
    trafficSources.content = '';
    // trafficSources.ID = 'University Activations'
  }


  let source =
    trafficSources.source.length === 0 ? "direct" : trafficSources.source;

  if (
    trafficSources.source.length === 0 &&
    (trafficSources.campaign.length === 0 ||
      trafficSources.gclid.length === 0 ||
      trafficSources.gbraid.length === 0 ||
      trafficSources.wbraid.length === 0 ||
      trafficSources.fbclid.length === 0 ||
      trafficSources.msclkid.length === 0 ||
      trafficSources.ttclid.length === 0)
  ) {
    source = "-";
  }

  const source_url =
    trafficSources.uri.length === 0 ? "direct" : trafficSources.uri;
  const medium =
    trafficSources.medium.length === 0 ? "none" : trafficSources.medium;
  const campaign =
    trafficSources.campaign.length === 0 ? "direct" : trafficSources.campaign;

  return Object.fromEntries(
    Object.entries({
      ...trafficSources,
      source: source,
      uri: source_url,
      medium: medium,
      campaign: campaign,
      pageviewcount: trafficSources?.pageviewcount || 0,
      date: new Date().toISOString().slice(0, 10).replaceAll('-', "")
    }).filter(([key, value]) => value !== "" && value != null)
  );
}
